import { useTranslate } from 'hooks/useTranslate';
import {
  formatCurrencyDecimals,
  formatNumber,
  formatNumberDecimals,
} from 'utils/formats';

function BeneficiaryIncentiveOperationRow({
  index,
  rowKey,
  units,
  soldUnits,
  status,
  societyId,
  operationId,
  beneficiaryId,
  retentionPercent,
  netAmount,
}) {
  const { t } = useTranslate();

  const handleNavigateToOperation = () => {
    window.location.href = `#/detalle-operacion-incentivos/${societyId}/${operationId}?beneficiaryId=${beneficiaryId}`;
  };

  return (
    <tr
      key={rowKey}
      onClick={handleNavigateToOperation}
      className="cursor-pointer"
    >
      <td className="fw-bold d-none d-md-table-cell">{index}</td>

      <td className="text-right d-none d-md-table-cell">
        {formatNumber(units)}
      </td>

      <td className="text-right d-none d-md-table-cell">
        {formatNumberDecimals(retentionPercent)}
      </td>

      <td className="text-right d-none d-md-table-cell">
        {formatCurrencyDecimals(netAmount)}
      </td>

      <td className="text-right">{formatNumber(soldUnits)}</td>

      <td className="text-left">
        <span className={`badge badge-check ${status?.style}`}>
          {t(status?.value) || ''}
        </span>
      </td>
    </tr>
  );
}

export default BeneficiaryIncentiveOperationRow;
